import { render } from "./GameMain.vue?vue&type=template&id=bbf5994c&scoped=true"
import script from "./GameMain.vue?vue&type=script&lang=js"
export * from "./GameMain.vue?vue&type=script&lang=js"

import "./GameMain.vue?vue&type=style&index=0&id=bbf5994c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bbf5994c"

export default script